export const defaultNotify = {
    type: '',
    action: '',
    text: ''
};
